import { Controller } from "@hotwired/stimulus";
import SignaturePad from "signature_pad";

export default class extends Controller {
  static targets = ["canvas", "form", "data", "error"];

  connect() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      backgroundColor: "rgb(255, 255, 255)",
      penColor: "rgb(0, 0, 0)",
    });
    this.resizeCanvas();
    window.addEventListener("resize", () => this.resizeCanvas());
    this.formTarget.addEventListener("submit", (event) => this.handleSubmit(event));
  }

  disconnect() {
    window.removeEventListener("resize", () => this.resizeCanvas());
  }

  resizeCanvas() {
    const canvas = this.canvasTarget;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const rect = canvas.getBoundingClientRect();
    const hadData = this.signaturePad && !this.signaturePad.isEmpty();
    const data = hadData ? this.signaturePad.toDataURL() : null;

    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    canvas.getContext("2d").scale(ratio, ratio);
    this.signaturePad.clear();
    if (data) {
      this.signaturePad.fromDataURL(data);
    }
  }

  clear() {
    this.signaturePad.clear();
    this.hideError();
  }

  handleSubmit(event) {
    this.hideError();
    if (this.signaturePad.isEmpty()) {
      event.preventDefault();
      this.showError("Please provide a signature.");
      return;
    }
    this.dataTarget.value = this.signaturePad.toDataURL("image/png");
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message;
      this.errorTarget.classList.remove("hidden");
    }
  }

  hideError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = "";
      this.errorTarget.classList.add("hidden");
    }
  }
}
